
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as indexzA_45GnG7kodXcNoPqptJKF6rvpkSVWdFGDZ0F7PFMN_45AMeta } from "/app/src/pages/login/index.vue?macro=true";
import { default as indexAVcLpknrTTsttJ4b6aRZuIK2I9qVuivaqWmcSbyxYgIMeta } from "/app/src/pages/welcome/index.vue?macro=true";
import { default as indexGqnjmwt6jSPjYExm_zPi_YgkoAzGRPG3SruK8OHdsJIMeta } from "/app/src/pages/dashboard-apo/index.vue?macro=true";
import { default as indexYc8sKulKG1Lo9be5cUAq_45HRkN_45YlRRYDv3USyL6jktUMeta } from "/app/src/pages/role-management/index.vue?macro=true";
import { default as index6kIMD7IVfUe2Uya94EnwUSKb_AhXq12yfrhGLjLG4coMeta } from "/app/src/pages/monitoring-tag-i/index.vue?macro=true";
import { default as indexHhEv_qsFh3SwwJ2PyYbjJN0Z3utPmRCW_zMcowuvQ1wMeta } from "/app/src/pages/monitoring-refund/index.vue?macro=true";
import { default as tracking_45reportXeqRp1dcxrb6b_1Q1BYP6XS6qf2LKCj3h7IIYM_6s_sMeta } from "/app/src/pages/tracking/tracking-report.vue?macro=true";
import { default as realtime_45trackingMKPNIs_AdRiYe9T8NTyTKRzBAykmLd3lP5aUdX7jatIMeta } from "/app/src/pages/tracking/realtime-tracking.vue?macro=true";
import { default as indexdPE6UzDgMm_YB_hXDw2h0fy9jZX_45YIIhpPmoY_45tWWLcMeta } from "/app/src/pages/claim-operational-sapa/index.vue?macro=true";
import { default as indexjQKfSAi_LZEGq5OdX_450zz2GmITMV_Vzpfcy2q4lfaE8Meta } from "/app/src/pages/monitoring-performance/index.vue?macro=true";
import { default as monitoring_45positionDZftj9giAHEpnw0dCy7hTz3zxEzJI_45WKiVZPt1Rzv_0Meta } from "/app/src/pages/tracking/monitoring-position.vue?macro=true";
import { default as refund_45alfagift7l56WWUcdsERez00D__SXNcfGWlabfHnq4WqvSnktWgMeta } from "/app/src/pages/monitoring-analytic/refund-alfagift.vue?macro=true";
import { default as alfagift_45apo_45asoqnR6VKD1S8A3CRE4fITmjVkhk0mTFEhg0_45d5vdiLdjUMeta } from "/app/src/pages/monitoring-analytic/alfagift-apo-aso.vue?macro=true";
import { default as index0jFtaEqTx7gudxWbkc0ZUg2OKrGLYxlfR8Q07pLUg2IMeta } from "/app/src/pages/claim-operational-sapa/claim-bbm/index.vue?macro=true";
import { default as indexv4OEHnqqFZvs72eJadOw7fkjW8rwwuAIDXVC1gKA_45N8Meta } from "/app/src/pages/claim-operational-sapa/maintenance/index.vue?macro=true";
import { default as alfagift_45late_45reasonL4LIyzeqRuek65VSfCec13_kQB_CRgnPZL5Rb4473wMMeta } from "/app/src/pages/monitoring-analytic/alfagift-late-reason.vue?macro=true";
import { default as gli_45sapa_45pending_45order9gsUJjmxHxSpyBYY0gC2u7C_45Zz9MxUS95FW8fjkL1NwMeta } from "/app/src/pages/monitoring-analytic/gli-sapa-pending-order.vue?macro=true";
import { default as indexk5KwXKRAxqOyMqjFUus3KFXxWvsW23dCdjL2AUKWC5AMeta } from "/app/src/pages/claim-operational-sapa/vehicle-config/index.vue?macro=true";
import { default as alfagift_45lapor_45equipmentelJ1xD5GIx8lt7aGmku6i1Shpv6OrUN_45_45BsjiXNdi9wMeta } from "/app/src/pages/monitoring-analytic/alfagift-lapor-equipment.vue?macro=true";
import { default as gli_45new_45sapa_45performancedoxScbHkXb0foRpVtPSANo3YfHmmOl9bOkIo9QW1hkYMeta } from "/app/src/pages/monitoring-analytic/gli-new-sapa-performance.vue?macro=true";
import { default as alfagift_45pengiriman_45tunda2xpsf9lea4WkoEGxNkdTWXPMN_45EEZ0PlJ8XVbJFm0bgMeta } from "/app/src/pages/monitoring-analytic/alfagift-pengiriman-tunda.vue?macro=true";
import { default as indexb1WirYacr_45wWf3ux0P5GjaFiqlBlFqKZFYnl13mKXLQMeta } from "/app/src/pages/claim-operational-sapa/vehicle-config/registered-vehicle/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["redirect-login"]},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexzA_45GnG7kodXcNoPqptJKF6rvpkSVWdFGDZ0F7PFMN_45AMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/app/src/pages/login/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/welcome/index.vue")
  },
  {
    name: "dashboard-apo",
    path: "/dashboard-apo",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/dashboard-apo/index.vue")
  },
  {
    name: "role-management",
    path: "/role-management",
    meta: indexYc8sKulKG1Lo9be5cUAq_45HRkN_45YlRRYDv3USyL6jktUMeta || {},
    component: () => import("/app/src/pages/role-management/index.vue")
  },
  {
    name: "monitoring-tag-i",
    path: "/monitoring-tag-i",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-tag-i/index.vue")
  },
  {
    name: "monitoring-refund",
    path: "/monitoring-refund",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-refund/index.vue")
  },
  {
    name: "tracking-tracking-report",
    path: "/tracking/tracking-report",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/tracking/tracking-report.vue")
  },
  {
    name: "tracking-realtime-tracking",
    path: "/tracking/realtime-tracking",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/tracking/realtime-tracking.vue")
  },
  {
    name: "claim-operational-sapa",
    path: "/claim-operational-sapa",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/claim-operational-sapa/index.vue")
  },
  {
    name: "monitoring-performance",
    path: "/monitoring-performance",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-performance/index.vue")
  },
  {
    name: "tracking-monitoring-position",
    path: "/tracking/monitoring-position",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/tracking/monitoring-position.vue")
  },
  {
    name: "monitoring-analytic-refund-alfagift",
    path: "/monitoring-analytic/refund-alfagift",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/refund-alfagift.vue")
  },
  {
    name: "monitoring-analytic-alfagift-apo-aso",
    path: "/monitoring-analytic/alfagift-apo-aso",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/alfagift-apo-aso.vue")
  },
  {
    name: "claim-operational-sapa-claim-bbm",
    path: "/claim-operational-sapa/claim-bbm",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/claim-operational-sapa/claim-bbm/index.vue")
  },
  {
    name: "claim-operational-sapa-maintenance",
    path: "/claim-operational-sapa/maintenance",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/claim-operational-sapa/maintenance/index.vue")
  },
  {
    name: "monitoring-analytic-alfagift-late-reason",
    path: "/monitoring-analytic/alfagift-late-reason",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/alfagift-late-reason.vue")
  },
  {
    name: "monitoring-analytic-gli-sapa-pending-order",
    path: "/monitoring-analytic/gli-sapa-pending-order",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/gli-sapa-pending-order.vue")
  },
  {
    name: "claim-operational-sapa-vehicle-config",
    path: "/claim-operational-sapa/vehicle-config",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/claim-operational-sapa/vehicle-config/index.vue")
  },
  {
    name: "monitoring-analytic-alfagift-lapor-equipment",
    path: "/monitoring-analytic/alfagift-lapor-equipment",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/alfagift-lapor-equipment.vue")
  },
  {
    name: "monitoring-analytic-gli-new-sapa-performance",
    path: "/monitoring-analytic/gli-new-sapa-performance",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/gli-new-sapa-performance.vue")
  },
  {
    name: "monitoring-analytic-alfagift-pengiriman-tunda",
    path: "/monitoring-analytic/alfagift-pengiriman-tunda",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/monitoring-analytic/alfagift-pengiriman-tunda.vue")
  },
  {
    name: "claim-operational-sapa-vehicle-config-registered-vehicle",
    path: "/claim-operational-sapa/vehicle-config/registered-vehicle",
    meta: {"middleware":["auth"]},
    component: () => import("/app/src/pages/claim-operational-sapa/vehicle-config/registered-vehicle/index.vue")
  }
]